<template>
    <div class="footer-holder" :id="id">
        <div class="footer">
            <div class="footer__buttons">
                <ul class="footer__buttons__legal">
                    <li>
                        <a href="https://www.ea.com/legal/privacy-and-cookie-policy" target="_blank">
                            PRIVACY AND COOKIE POLICY
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ea.com/legal/privacy-and-cookie-policy#information-for-california-residents" target="_blank">
                            NOTICE AT COLLECTION
                        </a>
                    </li>
                    <li>
                        <div id="teconsent" consent="0,1,2,3" aria-label="Open Cookie Preferences Modal" class="truste_caIcon_display" role="complementary">
                            <a
                                id="footer-privacy-choices"
                                href="#"
                                lang="en"
                                aria-haspopup="dialog"
                                aria-label="Cookie Preferences, opens a dedicated popup modal window"
                                class="truste_cursor_pointer"
                                @click.prevent="openPrivacyPreferences"
                                @keydown.space.prevent="openPrivacyPreferences">
                                YOUR PRIVACY CHOICES
                            </a>
                        </div>
                    </li>
                </ul>
                <ul class="footer__buttons__social">
                    <li>
                        <a href="https://www.instagram.com/respawn/" target="_blank">
                            <img src="../img/global/footer/icon-instagram.png" alt="Instagram">
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/respawn" target="_blank">
                            <img src="../img/global/footer/icon-twitter.png" alt="Twitter">
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/RespawnEntertainment/" target="_blank">
                            <img src="../img/global/footer/icon-facebook.png" alt="Facebook">
                        </a>
                    </li>
                </ul>
            </div>
            <div class="footer__copyright">
                © {{ new Date().getFullYear() }} Respawn Entertainment Trademarks belong to their respective owners. All rights reserved.
            </div>
        </div>
    </div>
</template>

<script>
    import { openTrustArcPreferences } from '@/helpers/trustArcConsent'

    export default {
        name: 'Footer',
        data() {
            return {

            }
        },
        props: {
            id: {
                type: String,
                required: false,
                default: 'footer'
            },
        },
        methods: {
            openPrivacyPreferences() {
                openTrustArcPreferences()

                const truste = window.truste
                if (truste && truste.eu && truste.eu.bindMap) {
                    truste.eu.bindMap.returnFocusTo = 'footer-privacy-choices'
                }
            }
        }
    }
</script>
